import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';
import { RootObjectOrganization } from '../types/allCertwatch';

export const useGetContactConnectionById = (candidateManagerId: string) => {
    return useQuery<RootObjectOrganization, Error>(
        ['certWatch', candidateManagerId],
        async () => {
            const jsonResponse = await request({
                endpoint: `certWatch/getCertWatchByContactId`,
            });

            if (!jsonResponse.success) {
                throw new Error('Failed to fetch CertWatch requests');
            }

            return jsonResponse.data as RootObjectOrganization;
        },
        {
            enabled: !!candidateManagerId,
            refetchOnWindowFocus: true,
        }
    );
};
